import { render } from "./scrollup.vue?vue&type=template&id=f1474e06&scoped=true"
import script from "./scrollup.vue?vue&type=script&lang=js"
export * from "./scrollup.vue?vue&type=script&lang=js"

import "./scrollup.vue?vue&type=style&index=0&id=f1474e06&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1474e06"]])

export default __exports__